<template>
  <div class="LKMunMehFormFooter">
    <v-layout>
      <v-layout class="LKMunMehFormFooter__layout">
        <v-btn
          color="primary"
          rounded
          outlined
          :disabled="loading"
          @click="$emit('prev')"
          v-text="readOnly ? 'Перейти назад' : 'Сохранить и перейти назад'"
        />
        <v-btn
          color="primary"
          rounded
          outlined
          :disabled="loading"
          class="ml-btn"
          @click="$emit('main')"
          v-text="'Главный раздел'"
        />
        <v-spacer />
        <v-btn
          v-if="!readOnly"
          color="primary"
          rounded
          outlined
          :loading="loading"
          :disabled="loading"
          @click="$emit('save')"
          v-text="'Сохранить'"
        />
        <v-btn
          color="primary"
          rounded
          :disabled="loading"
          class="ml-btn"
          @click="$emit('next')"
          v-text="readOnly ? 'Перейти далее' : 'Сохранить и перейти далее'"
        />
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'LKMunMehFormFooter',
  props: {
    loading: Boolean,
    readOnly: Boolean,
  },
}
</script>

<style scoped lang="scss">
.LKMunMehFormFooter {
  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  margin-top: 16px;

  .ml-btn {
    margin-left: 12px;
  }
}
</style>

